import { createI18n } from 'vue-i18n'

// ✅ Importă limbile

// 🗂️ Importă limbile deja existente
import ro from './locales/ro.json'
import en from './locales/en.json'
import bg from './locales/bg.json'
import uk from './locales/ua.json'
import sr from './locales/rs.json'
import el from './locales/gr.json'
import tr from './locales/tr.json'
import es from './locales/es.json'
import it from './locales/it.json'
import fr from './locales/fr.json'
import hu from './locales/hu.json'
import sq from './locales/al.json'

// 🆕 Limbi noi
import de from './locales/de.json'
import nl from './locales/nl.json'
import pl from './locales/pl.json'
import zh from './locales/zh.json'
import ar from './locales/ar.json'
import af from './locales/af.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import sl from './locales/sl.json'
import sk from './locales/sk.json'
import bs from './locales/bs.json'
import mk from './locales/mk.json'
import cs from './locales/cs.json'
import no from './locales/no.json'
import da from './locales/da.json'
import fi from './locales/fi.json'
import pt from './locales/pt.json'
import ne from './locales/ne.json'
import he from './locales/he.json'
import hi from './locales/hi.json'
import th from './locales/th.json'
import sv from './locales/sv.json'
import vi from './locales/vi.json'
import id from './locales/id.json'
import fa from './locales/fa.json'
import ur from './locales/ur.json'
import ru from './locales/ru.json'
import la from './locales/la.json'
// 🌐 Toate traducerile
const messages = {
  ro, en, bg, uk, sr, el, tr, es, it, fr, hu, sq,
  de, nl, pl, zh, ar, af, ja, ko,
  sl, sk, bs, mk, cs, no, da, fi, pt, ne,
  he, hi, th, sv, vi, id, fa, ur, ru, la
}


// 🌍 Detectează limba browserului
const browserLang = navigator.language.slice(0, 2)
const defaultLang = messages[browserLang] ? browserLang : 'ro'

// 🎯 Creează instanța
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || defaultLang,
  fallbackLocale: 'ro',
  messages
})

// 📦 Salvează limba browserului dacă nu e setată deja
if (!localStorage.getItem('lang') && messages[browserLang]) {
  i18n.global.locale.value = browserLang
}

// 🌐 Export pentru dropdown etc.
export const availableLanguages = Object.keys(messages)
export default i18n
